import { ActivityEntityName } from '../shared/activity.entity.name';
import { ContactType } from './contact.type';

export const ActivityName = Object.freeze({
  [ContactType.ServiceProvider]: ActivityEntityName.Customer,
  [ContactType.Business]: ActivityEntityName.Customer,
  [ContactType.Individual]: ActivityEntityName.Customer,
  [ContactType.Subcontractor]: ActivityEntityName.Contractor,
  [ContactType.Supplier]: ActivityEntityName.Supplier,
  [ContactType.WorkBuddyCompany]: ActivityEntityName.WorkBuddyCompany,
  [ContactType.Employee]: ActivityEntityName.ContactEmployee,
  [ContactType.BasicContact]: ActivityEntityName.BasicContact,
  [ContactType.LoginContact]: ActivityEntityName.LoginContact,
  [ContactType.Contact]: ActivityEntityName.Contact,
} satisfies Partial<Record<ContactType, ActivityEntityName>>);

export const ContactTypesByActivityName = Object.freeze({
  [ActivityEntityName.Customer]: Object.freeze([ContactType.ServiceProvider, ContactType.Business, ContactType.Individual]),
  [ActivityEntityName.Contractor]: Object.freeze([ContactType.Subcontractor]),
  [ActivityEntityName.Supplier]: Object.freeze([ContactType.Supplier]),
  [ActivityEntityName.WorkBuddyCompany]: Object.freeze([ContactType.WorkBuddyCompany]),
  [ActivityEntityName.ContactEmployee]: Object.freeze([ContactType.Employee]),
  [ActivityEntityName.BasicContact]: Object.freeze([ContactType.BasicContact]),
  [ActivityEntityName.LoginContact]: Object.freeze([ContactType.LoginContact]),
  [ActivityEntityName.Contact]: Object.freeze([ContactType.Contact]),
} satisfies Partial<Record<ActivityEntityName, readonly ContactType[]>>);
